// extracted by mini-css-extract-plugin
export default {"bell-icon":"CampaignPopUp_bell-icon__A-tSx","title":"CampaignPopUp_title__K6aB3","alert":"CampaignPopUp_alert__y5Kgl","close-btn":"CampaignPopUp_close-btn__tRAtV"};